<template>
  <div>
    <v-tabs flat background-color="transparent" class="mb-0">
      <v-tabs-slider color="green"></v-tabs-slider>
      <v-tab :to="{ name: 'affiliates' }" exact>
        Dashboard
      </v-tab>
      <v-tab :to="{ name: 'affiliates_banners' }" exact>
        Banners
      </v-tab>
      <v-tab :to="{ name: 'affiliates-campaigns' }" exact>
      Campaigns
      </v-tab>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-tab v-on="on">
            Statistics
            <v-icon>mdi-menu-down</v-icon>
          </v-tab>
        </template>
        <v-list class="grey lighten-3">
          <v-list-item :to="{ name: 'monthly-statistics'}">
            <v-list-item-title>Monthly Statistics</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'yearly-statistics'}">
            <v-list-item-title>Yearly Statistics</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'lifetime-statistics'}">
            <v-list-item-title>Lifetime Statistics</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'traffic-details'}">
            <v-list-item-title>Traffic Details</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
<!--      <v-tab :to="{ name: 'monthly-statistics' }" exact exact-path>-->
<!--        Statistics-->
<!--      </v-tab>-->
      <v-tab :to="{ name: 'affiliates_payments' }" exact>
        Payment History
      </v-tab>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-tab v-on="on">
            Legal
            <v-icon>mdi-menu-down</v-icon>
          </v-tab>
        </template>
        <v-list class="grey lighten-3">
          <v-list-item :to="{ name: 'affiliates_legal_tos'}">
            <v-list-item-title>Affiliate ToS</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'affiliates_legal_ftc'}">
            <v-list-item-title>FTC Guidelines</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
<!--      <v-tab :to="{ name: 'affiliates_legal_tos' }" exact>-->
<!--        Legal-->
<!--      </v-tab>-->
    </v-tabs>
    <hr class="mt-0 mb-md-4">
  </div>
</template>

<script>
export default {
  name: 'AffiliatesNavigation'
}
</script>
